export default {
    show_changes_history_title: "Change History",
    show_changes_history_version: "Version",
    show_changes_history_updated_on: "Updated On",
    show_changes_history_view_changes: "View Changes",
    show_changes_history_compare: "Compare",
    show_changes_history_settings: "Settings",
    show_changes_history_cloud_config: "Cloud Config",
    show_changes_history_compare_vesions: "Changes from version "
}